// extracted by mini-css-extract-plugin
export default {"flashing":"_02wcjMjhazKtyi","FLASH":"hTjRqaPmyZMjUHT"};